import { Link } from "react-router-dom";
import { GraduationCap, MapPin, Phone, Mail, Facebook, Instagram, Youtube } from "lucide-react";

export default function Footer() {
    return (
        <footer
            data-testid="footer"
            className="bg-unemi-blue-dark text-slate-300 mt-24"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
                <div className="md:col-span-2">
                    <div className="flex items-center gap-3 mb-5">
                        <span className="grid place-items-center w-11 h-11 rounded-xl bg-unemi-orange-primary text-white">
                            <GraduationCap className="w-5 h-5" />
                        </span>
                        <div>
                            <p className="font-heading text-xl text-white font-semibold">
                                Universidad Estatal de Milagro
                            </p>
                            <p className="text-[10px] uppercase tracking-[0.2em] text-unemi-orange-primary font-bold">
                                Posgrados · UNEMI
                            </p>
                        </div>
                    </div>
                    <p className="text-sm leading-relaxed max-w-md text-slate-400">
                        Forma profesionales con visión global. Maestrías acreditadas,
                        modalidad en línea y presencial, con financiamiento flexible para
                        impulsar tu carrera.
                    </p>
                    <div className="flex gap-3 mt-6">
                        {[Facebook, Instagram, Youtube].map((Icon, i) => (
                            <a
                                key={i}
                                href="#"
                                className="grid place-items-center w-10 h-10 rounded-full border border-slate-700 hover:border-unemi-orange-primary hover:text-unemi-orange-primary transition-colors"
                            >
                                <Icon className="w-4 h-4" />
                            </a>
                        ))}
                    </div>
                </div>

                <div>
                    <p className="text-xs uppercase tracking-[0.2em] font-bold text-unemi-orange-primary mb-4">
                        Enlaces
                    </p>
                    <ul className="space-y-3 text-sm">
                        <li><Link to="/" className="hover:text-white">Todas las escuelas</Link></li>
                        <li><Link to="/educacion" className="hover:text-white">Educación y Comunicación</Link></li>
                        <li><Link to="/ciencias" className="hover:text-white">Ciencias e Ingeniería</Link></li>
                        <li><Link to="/negocios" className="hover:text-white">Negocios</Link></li>
                        <li><Link to="/salud" className="hover:text-white">Salud</Link></li>
                        <li><Link to="/derecho" className="hover:text-white">Derecho</Link></li>
                    </ul>
                </div>

                <div>
                    <p className="text-xs uppercase tracking-[0.2em] font-bold text-unemi-orange-primary mb-4">
                        Contacto
                    </p>
                    <ul className="space-y-3 text-sm text-slate-400">
                        <li className="flex gap-2"><MapPin className="w-4 h-4 mt-0.5 text-unemi-orange-primary" /> Cdla. Universitaria Km. 1.5 vía Km. 26, Milagro - Ecuador</li>
                        <li className="flex gap-2"><Phone className="w-4 h-4 mt-0.5 text-unemi-orange-primary" /> +593 4 271-5081</li>
                        <li className="flex gap-2"><Mail className="w-4 h-4 mt-0.5 text-unemi-orange-primary" /> posgrados@unemi.edu.ec</li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-slate-800">
                <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between text-xs text-slate-500">
                    <p>© {new Date().getFullYear()} Universidad Estatal de Milagro. Todos los derechos reservados.</p>
                </div>
            </div>
        </footer>
    );
}
